import React from 'react';
import ReactTooltip from 'react-tooltip';
import { User } from '../models';
import { IconConfusedFace } from '../utils';
import {
    CSSTransition,
    TransitionGroup,
    SwitchTransition,
} from 'react-transition-group';

interface PhotoProps {
    openInNewTab: boolean;
    photo: string;
    link?: string;
    className?: string;
    tooltip?: string;
}

interface PhotoState {
    photo: string;
}

export class Photo extends React.Component<PhotoProps, PhotoState> {

    state: PhotoState = {
        photo: null,
    };

    constructor(props: PhotoProps) {
        super(props)
    }

    componentDidMount() {
        if (this.props.photo == null) {
            return;
        }
        this.setState({ photo: this.props.photo });
    }

    componentDidUpdate(prevProps: PhotoProps, prevState: PhotoState) {
        if (this.props.photo != null && prevProps.photo != this.props.photo) {
            this.setState({ photo: this.props.photo });
        }
    }

    render() {
        const { children, className, photo, link, tooltip, openInNewTab } = this.props;

        if (photo === null) {
            return <a className={`${typeof className !== 'undefined' ? className : ''} empty`}>
                <IconConfusedFace />
            </a>;
        }

        return <>
            <a className={className} href={link} data-tip={tooltip} target={openInNewTab ? '_blank' : '_self'}>
                <TransitionGroup className="transition-group">
                    <CSSTransition
                        classNames="fade"
                        timeout={{ enter: 600, exit: 600 }}
                        key={this.state.photo}>
                        <img src={this.state.photo} />
                    </CSSTransition>
                </TransitionGroup>
                {children}
            </a>
            <ReactTooltip type="dark" backgroundColor="#eeeeee" borderColor="#ffffff" border={true} textColor="#000000" place="bottom" effect="solid" offset={{ bottom: -8 }} />
        </>;
    }
}